import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  title: {
    marginLeft: spacing.xs,
    fontWeight: 500,
    flexGrow: 1,
  },
};
